<template>
  <div class="d-flex">
    <div class="mt-5 d-flex justify-start">
      <!-- [구필터UI]
       <div
        class="mb-2 d-flex justify-center align-center text-center filter-btn mr-5 "
        @click="filterModal = true"
        v-if="sendStatus"
      >
        <img src="/static/drawer/filter.svg" width="20px" height="20px" />
        <div class="pl-1">필터</div>
      </div> 
       <div
        class="justify-center align-center d-flex text-center filter-btn1 mr-5 "
        @click="filterModal = true"
        v-else
      >
        <img src="/static/drawer/filter1.svg" width="20px" height="20px" />
        <span class="pl-1">필터</span>
      </div> -->

      <button type="button" @click="filterModal = true" style="height: 32px;">
        <FilterTriggerBtn class="mb-2 mr-2" :isActive="!sendStatus" />
      </button>

      <div
        class="d-flex align-center filter-content"
        style="overflow-y:auto;white-space:nowrap;flex-wrap: wrap;"
        v-if="Object.keys(sendList).length"
      >
        <div class="filter-status mr-4" v-if="sendList.startDate">
          {{
            `기간 설정 : ${
              sendList.endDate ? sendList.startDate + " ~" : sendList.startDate
            } ${sendList.endDate ? sendList.endDate : ""}`
          }}
        </div>
        <div
          class="filter-range mr-4"
          v-if="
            sendList.filterYearMonthList && sendList.filterYearMonthList.length
          "
        >
          {{ "구간 설정 : " + `${sendList.filterYearMonthList.join(", ")}` }}
        </div>
        <!-- <div
          class="filter-status mr-4"
          v-if="sendList.filterYearList && sendList.filterYearList.length"
        >
          {{
            "구간 설정(년): " +
              `${filterText(sendList.filterYearList, "년", yearList)}`
          }}
        </div>
        <div
          class="filter-status mr-4"
          v-if="sendList.filterYearList && sendList.filterMonthList.length"
        >
          {{
            "구간 설정(월): " +
              `${filterText(sendList.filterMonthList, "월", monthList)}`
          }}
        </div> -->
        <div class="filter-status mr-4" v-if="sendList.filterStatusList.length">
          {{
            `${statusName}: ${filterText(
              sendList.filterStatusList,
              null,
              sendStatusList
            )}`
          }}
        </div>
        <div class="filter-status mr-4" v-if="sendList.filterDongList.length">
          {{
            "동: " + `${filterText(sendList.filterDongList, null, dongList)}`
          }}
        </div>
        <div class="filter-status mr-4" v-if="sendList.filterFloorList.length">
          {{
            "층: " + `${filterText(sendList.filterFloorList, null, floorList)}`
          }}
        </div>
        <div class="filter-status" v-if="sendList.filterTypeList.length">
          {{
            "부재: " + `${filterText(sendList.filterTypeList, null, typeList)}`
          }}
        </div>
      </div>
    </div>
    <v-dialog
      :width="statusName ? 920 : 800"
      v-model="filterModal"
      :resizable="false"
      style="z-index:11;border:1px solid white;"
    >
      <v-card
        :width="statusName ? 920 : 800"
        style="z-index:5;border:1px solid white;"
      >
        <div class="topper-text">조회 조건</div>

        <div class="d-flex px-5 py-4">
          <v-card
            class="innerContent"
            width="350"
            min-height="420"
            max-height="420"
            :elevation="0"
          >
            <v-row class="ma-0 pa-0 justify-center align-center">
              <div class="body-text">조회기간</div>
              <v-spacer />
              <div style="width:130px; ">
                <v-select
                  hide-details
                  solo
                  flat
                  dense
                  class="custom-select"
                  item-color="blue accent-4"
                  append-icon="mdi-chevron-down"
                  :menu-props="{ offsetY: true }"
                  :items="listItems"
                  item-text="searchText"
                  item-value="searchValue"
                  :disabled="!modalStatus"
                  v-model="selectList"
                ></v-select>
              </div>
            </v-row>
            <v-row class="ma-0 pa-0 mt-4 mb-4">
              <v-radio-group v-model="dateCheck" hide-details>
                <v-radio label="기간 설정" value="dateRange"></v-radio>
              </v-radio-group>
            </v-row>
            <v-row
              class="ma-0 pa-0 align-center justify-center"
              style="width:100%"
            >
              <div class="d-flex flex-column mr-4">
                <div class="range-date-title">시작일</div>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  type="month"
                  :return-value.sync="dates"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div class="input-range">
                      <DateIcon width="18" height="18" />
                      <input
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :value="dates.replaceAll('-', '.')"
                        class="cursor-pointer"
                      />
                    </div>
                  </template>
                  <v-date-picker
                    v-model="dates"
                    no-title
                    scrollable
                    locale="kr"
                    color="#3F557D"
                    class="filter-date justify-center align-center"
                  >
                  </v-date-picker>
                  <div class="d-flex white px-5 pb-4" style="gap:12px">
                    <v-btn
                      @click="insertDatas(dates)"
                      dark
                      color="#8CA9DD"
                      height="36"
                      class="picker-btn"
                    >
                      선택
                    </v-btn>
                    <v-btn
                      @click="menu = false"
                      color="#EEEEEE"
                      height="36"
                      class="picker-btn"
                    >
                      닫기
                    </v-btn>
                  </div>
                </v-menu>
              </div>

              <div class="d-flex flex-column">
                <div class="range-date-title">종료일</div>
                <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="false"
                  :return-value.sync="dates1"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <div class="input-range">
                      <DateIcon width="18" height="18" />
                      <input
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :value="dates1.replaceAll('-', '.')"
                        class="cursor-pointer"
                      />
                    </div>
                  </template>
                  <v-date-picker
                    v-model="dates1"
                    no-title
                    scrollable
                    locale="kr"
                    color="#3F557D"
                    class="filter-date justify-center align-center"
                  >
                  </v-date-picker>

                  <div class="d-flex white px-5 pb-4" style="gap:12px">
                    <v-btn
                      @click="insertDatas1(dates1)"
                      dark
                      color="#8CA9DD"
                      height="36"
                      class="picker-btn"
                    >
                      선택
                    </v-btn>
                    <v-btn
                      @click="menu1 = false"
                      color="#EEEEEE"
                      height="36"
                      class="picker-btn"
                    >
                      닫기
                    </v-btn>
                  </div>
                </v-menu>
              </div>
            </v-row>
            <!-- <perfect-scrollbar :style="{ height: cardHeight - 220 + 'px' }"> -->
            <v-row class="ma-0 pa-0 mt-6 mb-2">
              <v-radio-group v-model="dateCheck" hide-details>
                <v-radio label="구간 설정" value="range"></v-radio>
              </v-radio-group>
            </v-row>

            <div @click="dateCheck = 'range'">
              <FilterYearMonthPanel
                ref="filterPanelRef"
                :yearList="yearLabels"
                :activeMonths="yearMonthList"
                :maxHeight="cardHeight - 220 + 'px'"
                @onSelectYearMonth="onSelectYearMonth"
              />
            </div>
            <!-- <v-row class="ma-0 pa-0 justify-center align-center ">
                <span class="month-year-text mr-2">년</span>
                <span class="month-year-text">월</span>
              </v-row>
              <v-row class="ma-0 pa-0">
                <v-list class="width-140">
                  <v-list-item
                    class="min-height-23"
                    @click="totalStatus(yearTotal, yearList)"
                  >
                    <v-checkbox
                      label="전체"
                      dense
                      hide-details
                      color="white"
                      class="mt-0"
                      readonly
                      v-model="yearTotal"
                    >
                    </v-checkbox>
                  </v-list-item>
                  <v-list-item
                    v-for="(i, index) of yearList"
                    :key="index"
                    class="min-height-28"
                    @click="addList(yearList, i.name, index)"
                  >
                    <v-checkbox
                      dense
                      hide-details
                      readonly
                      class="mt-0"
                      :label="i.name + ''"
                      color="white"
                      v-model="yearList[index].status"
                      >{{ i.name }}</v-checkbox
                    >
                  </v-list-item>
                </v-list>
                <v-list class=" width-140">
                  <v-list-item
                    class="min-height-23"
                    @click="totalStatus(monthTotal, monthList)"
                  >
                    <v-checkbox
                      label="전체"
                      dense
                      hide-details
                      color="white"
                      class="mt-0"
                      readonly
                      v-model="monthTotal"
                    >
                    </v-checkbox>
                  </v-list-item>
                  <v-list-item
                    v-for="(i, index) of monthList"
                    :key="index"
                    class="min-height-28"
                    @click="addList(monthList, i.name, index)"
                  >
                    <v-checkbox
                      dense
                      hide-details
                      readonly
                      class="mt-0"
                      :label="i.name + '월'"
                      color="white"
                      v-model="monthList[index].status"
                      >{{ i.name }}</v-checkbox
                    >
                  </v-list-item>
                </v-list>
              </v-row> -->
            <!-- </perfect-scrollbar> -->
          </v-card>
          <v-card
            v-if="statusName"
            class="innerContent"
            width="150"
            :elevation="0"
          >
            <div class="body-text pl-2">{{ statusName }}</div>
            <perfect-scrollbar :style="{ maxHeight: '230px' }">
              <v-list class="innerContent">
                <v-list-item
                  class="min-height-23"
                  @click="totalStatus(statusTotal, sendStatusList)"
                >
                  <v-checkbox
                    label="전체"
                    dense
                    hide-details
                    color="#3a6eff"
                    class="mt-0"
                    readonly
                    v-model="statusTotal"
                  >
                  </v-checkbox>
                </v-list-item>
                <v-list-item
                  v-for="(i, index) of sendStatusList"
                  :key="index"
                  class="min-height-28"
                  @click="addList(sendStatusList, i.name, index)"
                >
                  <v-checkbox
                    dense
                    hide-details
                    readonly
                    class="mt-0"
                    :label="i.name"
                    color="#3a6eff"
                    v-model="sendStatusList[index].status"
                    >{{ i.name }}</v-checkbox
                  >
                </v-list-item>
              </v-list>
            </perfect-scrollbar>
            <perfect-scrollbar
              :style="{ maxHeight: '200px' }"
              v-if="roleStatus && modalStatus"
            >
              <v-list class=" innerContent mt-3">
                <div class="body-text pl-2 ">샵업체</div>
                <v-list-item
                  class="min-height-23"
                  @click="totalStatus(orderTotal, orderCompanyList)"
                >
                  <v-checkbox
                    label="전체"
                    dense
                    hide-details
                    color="#3a6eff"
                    class="mt-0"
                    readonly
                    v-model="orderTotal"
                  >
                  </v-checkbox>
                </v-list-item>
                <v-list-item
                  v-for="(i, index) of orderCompanyList"
                  :key="index"
                  class="min-height-28"
                  @click="addList(orderCompanyList, i.name, index)"
                >
                  <v-checkbox
                    dense
                    hide-details
                    readonly
                    class="mt-0"
                    :label="i.name"
                    color="#3a6eff"
                    v-model="orderCompanyList[index].status"
                    >{{ i.name }}</v-checkbox
                  >
                </v-list-item>
              </v-list>
            </perfect-scrollbar>
            <perfect-scrollbar
              :style="{ maxHeight: '200px' }"
              v-if="roleStatus && modalStatus"
            >
              <v-list class=" innerContent mt-3">
                <div class="body-text pl-2">가공장</div>
                <v-list-item
                  class="min-height-23"
                  @click="totalStatus(invoiceTotal, invoiceCompanyList)"
                >
                  <v-checkbox
                    label="전체"
                    dense
                    hide-details
                    color="#3a6eff"
                    class="mt-0"
                    readonly
                    v-model="invoiceTotal"
                  >
                  </v-checkbox>
                </v-list-item>
                <v-list-item
                  v-for="(i, index) of invoiceCompanyList"
                  :key="index"
                  class="min-height-28"
                  @click="addList(invoiceCompanyList, i.name, index)"
                >
                  <v-checkbox
                    dense
                    hide-details
                    readonly
                    class="mt-0"
                    :label="i.name"
                    color="#3a6eff"
                    v-model="invoiceCompanyList[index].status"
                    >{{ i.name }}</v-checkbox
                  >
                </v-list-item>
              </v-list>
            </perfect-scrollbar>
          </v-card>
          <v-card
            class="innerContent"
            width="150"
            max-height="420"
            :elevation="0"
          >
            <div class="body-text pl-2 mb-2">동</div>
            <perfect-scrollbar :style="{ height: cardHeight - 50 + 'px' }">
              <v-list class="innerContent pa-0">
                <v-list-item
                  class="min-height-23"
                  @click="totalStatus(dongTotal, dongList)"
                >
                  <v-checkbox
                    label="전체"
                    dense
                    hide-details
                    color="#3a6eff"
                    class="mt-0"
                    readonly
                    v-model="dongTotal"
                  >
                  </v-checkbox>
                </v-list-item>
                <v-list-item
                  v-for="(i, index) of dongList"
                  :key="index"
                  class="min-height-28"
                  @click="addList(dongList, i.name, index)"
                >
                  <v-checkbox
                    dense
                    hide-details
                    readonly
                    class="mt-0"
                    :label="i.name"
                    color="#3a6eff"
                    v-model="dongList[index].status"
                    >{{ i.name }}</v-checkbox
                  >
                </v-list-item>
              </v-list>
            </perfect-scrollbar>
          </v-card>
          <v-card
            class="innerContent"
            width="150"
            max-height="420"
            :elevation="0"
          >
            <div class="body-text pl-2 pb-2">층</div>
            <perfect-scrollbar :style="{ height: cardHeight - 50 + 'px' }">
              <v-list
                class="innerContent pa-0"
                :style="{ maxHeight: cardHeight - 50 + 'px' }"
              >
                <v-list-item
                  class="min-height-23"
                  @click="totalStatus(floorTotal, floorList)"
                >
                  <v-checkbox
                    label="전체"
                    dense
                    hide-details
                    color="#3a6eff"
                    class="mt-0"
                    readonly
                    v-model="floorTotal"
                  >
                  </v-checkbox>
                </v-list-item>
                <v-list-item
                  v-for="(i, index) of floorList"
                  :key="index"
                  class="min-height-28"
                  @click="addList(floorList, i.name, index)"
                >
                  <v-checkbox
                    dense
                    hide-details
                    readonly
                    class="mt-0"
                    :label="i.name"
                    color="#3a6eff"
                    v-model="floorList[index].status"
                    >{{ i.name }}</v-checkbox
                  >
                </v-list-item>
              </v-list>
            </perfect-scrollbar>
          </v-card>
          <v-card class="innerContent" width="150" :elevation="0">
            <div class="body-text pl-2 pb-2">부재</div>
            <perfect-scrollbar :style="{ height: cardHeight - 50 + 'px' }">
              <v-list class="innerContent pa-0" style="max-height:650px">
                <v-list-item
                  class="min-height-23"
                  @click="totalStatus(typeTotal, typeList)"
                >
                  <v-checkbox
                    label="전체"
                    dense
                    hide-details
                    color="#3a6eff"
                    class="mt-0"
                    readonly
                    v-model="typeTotal"
                  >
                  </v-checkbox>
                </v-list-item>
                <v-list-item
                  v-for="(i, index) of typeList"
                  :key="index"
                  class="min-height-28"
                  @click="addList(typeList, i.name, index)"
                >
                  <v-checkbox
                    dense
                    hide-details
                    readonly
                    class="mt-0"
                    :label="i.name"
                    color="#3a6eff"
                    v-model="typeList[index].status"
                    >{{ i.name }}</v-checkbox
                  >
                </v-list-item>
              </v-list>
            </perfect-scrollbar>
          </v-card>
        </div>
        <v-row
          class="ma-0 justify-center align-center d-flex bottom-btns"
          v-if="!minimize"
        >
          <v-btn
            class="mr-5 btn-text"
            width="200"
            height="51"
            style="color:#8CA9DD;border:1px solid #8ca9dd;background:white"
            @click="totalSelect(totalListStatus)"
          >
            {{ totalListStatus ? "전체 선택 해제" : "전체 선택" }}
          </v-btn>
          <v-btn
            class="mr-5 btn-text"
            width="200"
            height="51"
            dark
            color="#8CA9DD"
            @click="sendFilterData"
          >
            조회
          </v-btn>
          <v-btn
            width="200"
            class="btn-text"
            height="51"
            @click="onCancel"
            color="#c7c7c7"
          >
            취소
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { PerfectScrollbar } from "vue2-perfect-scrollbar";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";
import DatePickerMixin from "@/mixin/DatePicker";
import lodash from "lodash";
import FilterYearMonthPanel from "@/components/filter/FilterYearMonthPanel.vue";
import FilterTriggerBtn from "@/components/filter/FilterTriggerBtn.vue";
import DateIcon from "@/assets/svgs/DateIcon.vue";

export default {
  name: "FilterModal",
  props: [
    "filterList",
    "listItems",
    "statusList",
    "statusName",
    "noSend",
    "orderInvoice",
  ],
  components: {
    PerfectScrollbar,
    FilterYearMonthPanel,
    FilterTriggerBtn,
    DateIcon,
  },
  mixins: [DatePickerMixin],
  data: () => ({
    filterModal: false,
    cardHeight: 435,
    minimize: false,
    width: 150,
    orderStatus: [],
    dongList: [],
    floorList: [],
    partList: [],
    yearList: [],
    yearMonthList: [],
    yearLabels: [],
    monthList: [
      { name: "1", status: true },
      { name: "2", status: true },
      { name: "3", status: true },
      { name: "4", status: true },
      { name: "5", status: true },
      { name: "6", status: true },
      { name: "7", status: true },
      { name: "8", status: true },
      { name: "9", status: true },
      { name: "10", status: true },
      { name: "11", status: true },
      { name: "12", status: true },
    ],
    typeList: [],

    minDate: "",
    maxDate: "",
    dateCheck: "dateRange",

    selectList: 1,
    sendStatusList: [
      {
        name: "입고완료",
        status: true,
      },
      {
        name: "발주완료",
        status: true,
      },
      {
        name: "출고완료",
        status: true,
      },
      {
        name: "일부입고",
        status: true,
      },
    ],
    listCateList: [
      "typeList",
      "floorList",
      "yearList",
      "sendStatusList",
      "dongList",
      "invoiceCompanyList",
      "orderCompanyList",
    ],
    invoiceCompanyList: [],
    orderCompanyList: [],
    dates: new Date().toISOString().split("T")[0],
    dates1: new Date().toISOString().split("T")[0],
    menu: false,
    menu1: false,
    sendList: {},
  }),

  watch: {
    filterList(val) {
      if (val) {
        this.dates = val.minDate;

        // [기간필터 세팅] 이미 저장된 스토어 있으면 저장값 사용
        this.setFilterYearMonthList();

        /** 저장된 필터 있으면 기본필터 세팅 넘어가기 */
        if (this.storeFilter && Object.keys(this.storeFilter).length) {
          return;
        }
        this.settingList(val);
      }
    },
    filterModal(val) {
      if (!val) {
        if (this.isStoreFilter) {
          return this.setFilterFromStore({ storeVal: this.storeFilter });
        }
        this.settingList(this.filterList);
      } else {
        if (this.isStoreFilter) {
          this.setFilterYearMonthList();
        }
      }
    },
  },
  computed: {
    typeTotal() {
      return this.typeList.every((a) => a.status);
    },

    floorTotal() {
      return this.floorList.every((a) => a.status);
    },

    yearTotal() {
      return this.yearList.every((a) => a.status);
    },

    monthTotal() {
      return this.monthList.every((a) => a.status);
    },
    yearMonthTotal() {
      if (this.dateCheck === "dateRange") return true;
      return (
        this.filterList.yearMonthList?.length <= this.yearMonthList?.length
      );
    },

    statusTotal() {
      return this.sendStatusList.every((a) => a.status);
    },

    dongTotal() {
      return this.dongList.every((a) => a.status);
    },

    invoiceTotal() {
      return this.invoiceCompanyList.every((a) => a.status);
    },

    orderTotal() {
      return this.orderCompanyList.every((a) => a.status);
    },

    totalListStatus() {
      return (
        this.typeTotal &&
        this.floorTotal &&
        this.yearTotal &&
        this.monthTotal &&
        this.statusTotal &&
        this.dongTotal &&
        this.orderTotal &&
        this.invoiceTotal &&
        this.yearMonthTotal
      );
    },
    sendStatus() {
      for (let i in this.sendList) {
        if (i != "dateType") {
          if (this.sendList[i].length > 0) {
            return false;
          }
        }
      }
      return true;
    },

    roleStatus() {
      let roleType = this.$store.getters.getUserList.roleType;
      return roleType == "시스템관리자" || roleType == "현장관리자";
    },

    modalStatus() {
      return this.listItems.length != 1;
    },

    storeFilterList() {
      return this.$store.getters.getFilter;
    },
    curFilterType() {
      const curPath = this.$route.path.replace("/", "");
      const path = {
        orderinvoice: "발주입고",
        order: "발주",
        invoice: "출고",
        store: "입고",
      };
      return path[curPath];
    },
    storeFilter() {
      const curPath = this.$route.path.replace("/", "");
      const path = {
        orderinvoice: "getOrderInvoiceFilter",
        order: "getOrderFilter",
        invoice: "getInvoiceFilter",
        store: "getStoreFilter",
      };

      return this.$store.getters[path[curPath]];
    },
    /** 저장된 필터 있는지 여부 */
    isStoreFilter() {
      return this.storeFilter && Object.keys(this.storeFilter)?.length;
    },
  },
  mounted() {
    this.date = this.$moment(new Date()).format("YYYY-MM");
    this.date1 = this.$moment(new Date()).format("YYYY-MM");
    this.sendStatusList = this.statusList;

    if (this.isStoreFilter) {
      this.setFilterFromStore({ storeVal: this.storeFilter });
      return this.sendFilterData();
    }
    if (this.orderInvoice == "Y" && this.storeFilterList) {
      // this.setFilter();
      this.sendFilterData();
    }
  },
  methods: {
    /** [기간필터 세팅] 이미 저장된 스토어 있으면 저장값 사용 */
    setFilterYearMonthList() {
      let targetYearMonthList;
      if (this.isStoreFilter) {
        targetYearMonthList = this.storeFilter.filterYearMonthList
          ? this.storeFilter.filterYearMonthList
          : this.filterList?.yearMonthList;
      } else {
        targetYearMonthList = this.filterList?.yearMonthList;
      }
      this.yearMonthList = targetYearMonthList.map((el) =>
        el.replace("-", ".")
      );
      this.yearLabels = [
        ...new Set(
          this.filterList?.yearMonthList.map((date) => date.split("-")[0])
        ),
      ];
    },
    onSelectYearMonth({ checkedMonths }) {
      this.yearMonthList = checkedMonths;
    },
    /** 스토어에서 가져와서 필터 개별변수에 세팅하는 함수 */
    setFilterFromStore({ storeVal }) {
      Object.entries(storeVal).forEach(([fieldName, fieldValue]) => {
        if (fieldName === "startDate") {
          this.dates = fieldValue;
        } else if (fieldName === "endDate") {
          this.dates1 = fieldValue;
        } else if (fieldName === "filterYearMonthList") {
          this.yearMonthList = fieldValue;
        }
        this[fieldName] = lodash.cloneDeep(fieldValue);
      });
    },
    setFilter() {
      this.dongList = this.storeFilterList.dongList;
      this.floorList = this.storeFilterList.floorList;
      this.typeList = this.storeFilterList.typeList;
      this.sendStatusList = this.storeFilterList.sendStatusList;
      this.orderCompanyList = this.storeFilterList.orderCompanyList;
      this.invoiceCompanyList = this.storeFilterList.invoiceCompanyList;
      this.selectList = this.storeFilterList.selectList;
      if (this.dateCheck == "dateRange") {
        this.dates = this.storeFilterList.startDate;
        this.dates1 = this.storeFilterList.endDate;
      } else {
        this.yearList = this.storeFilterList.yearMonthList;
        this.monthList = this.storeFilterList.monthList;
      }
    },
    splitDate(val) {
      let s = val.split("-");
      return `${s[0]}년 ${s[1]}월`;
    },
    insertDatas(payload) {
      if (payload > this.dates1) {
        this.dates1 = payload;
        this.menu = true;
      } else {
        this.$refs.menu.save(payload);
        this.menu1 = true;
      }
    },
    insertDatas1(payload) {
      if (payload < this.dates) {
        this.dates = payload;
        this.menu1 = true;
      } else this.$refs.menu1.save(payload);
    },
    totalSelect(payload) {
      for (let i of this.listCateList) {
        this[i].map((a) => (a.status = !payload));
        this[i].sort();
      }
      if (payload) {
        this.dateCheck = "";
      } else {
        this.dateCheck = "dateRange";
      }
      this.$refs.filterPanelRef.initFilter();
    },
    statusTotala() {
      return this.list.filter((a) => !a).length == 0;
    },

    totalStatus(payload, list) {
      list.map((a) => (a.status = !payload));
      list.sort();
    },
    addList(list, value, index) {
      list[index] = {
        name: value,
        status: !list[index].status,
        id: list[index].id,
      };
      list.sort();
    },

    settingList(list) {
      if (!list) return;
      for (let i of this.listCateList) {
        if (
          i != "success" &&
          i != "minDate" &&
          i != "sendStatusList" &&
          i != "invoiceCompanyList" &&
          i != "orderCompanyList"
        ) {
          for (let j = 0; j < list[i]?.length; j++) {
            this[i][j] = {
              name: list[i][j],
              status: true,
            };
          }
        } else if (i == "invoiceCompanyList" || i == "orderCompanyList") {
          for (let j = 0; j < list[i]?.length; j++) {
            this[i][j] = {
              name: list[i][j].companyName,
              status: true,
              id: list[i][j].companyId,
            };
          }
          this[i] = this[i].filter((a) => a.companyName == "미지정");
        }
      }
    },

    filteringList(val) {
      return val.filter((a) => a.status).map((a) => a.name);
    },

    filteringIdList(val) {
      return val.filter((a) => a.status).map((a) => a.id);
    },

    sendFilterData() {
      let data = {
        filterDongList: this.filteringList(this.dongList),
        filterFloorList: this.filteringList(this.floorList),
        filterTypeList: this.filteringList(this.typeList),
        filterStatusList: this.filteringList(this.sendStatusList),
        dateType: this.noSend ? this.selectList : null,
        filterOrderCompanyList: this.filteringIdList(this.orderCompanyList),
        filterInvoiceCompanyList: this.filteringIdList(this.invoiceCompanyList),
      };
      if (this.dateCheck == "dateRange") {
        // data.startDate = this.$moment(this.dates).format("YYYY-MM");
        // data.endDate = this.$moment(this.dates1).format("YYYY-MM");
        data.startDate = this.dates;
        data.endDate = this.dates1;
      } else {
        // data.filterYearList = this.filteringList(this.yearList);
        // data.filterMonthList = this.filteringList(this.monthList);
        data.filterYearMonthList = this.yearMonthList;
      }
      let payload = {
        dongList: this.dongList,
        floorList: this.floorList,
        typeList: this.typeList,
        sendStatusList: this.sendStatusList,
        orderCompanyList: this.orderCompanyList,
        invoiceCompanyList: this.invoiceCompanyList,
        selectList: this.selectList,
        dateCheck: this.dateCheck,
      };

      if (this.dateCheck == "dateRange") {
        payload.startDate = this.dates;
        payload.endDate = this.dates1;
      } else {
        payload.yearLabels = this.yearLabels;
        payload.filterYearMonthList = this.yearMonthList;
        // payload.yearList = this.yearList;
        // payload.monthList = this.monthList;
      }
      this.$store.commit("setFilter", payload);
      this.sendList = this.totalListStatus ? {} : data; // 전체선택시 비우기
      this.$emit("sendFilterData", data); // 부모에 전송

      const clonePayload = lodash.cloneDeep(payload);
      const isTotalSelect = Object.keys(this.sendList).length;
      this.setFilterStore(isTotalSelect ? clonePayload : null);

      this.filterModal = false;
      setTimeout(() => {
        this.floorList.sort();
      }, 100);
    },
    /** 페이지 별 필터목록 스토어 저장 함수 */
    setFilterStore(filter) {
      const filterTypeList = {
        발주입고: "setOrderInvoiceFilter",
        발주: "setOrderFilter",
        출고: "setInvoiceFilter",
        입고: "setStoreFilter",
      };
      // console.log("[스토어 저장]", this.curFilterType, filter);
      this.$store.commit(filterTypeList[this.curFilterType], filter);
    },
    filterText(list, payload, compareList) {
      let returnData = "";
      if (!list) return "";
      if (compareList.length == list.length) return "전체선택";
      for (let i = 0; i < list.length; i++) {
        returnData +=
          list[i] +
          (payload ? payload : "") +
          (list.length - 1 == i ? " " : ", ");
      }
      return returnData;
    },
    onCancel() {
      if (this.isStoreFilter) {
        this.setFilterFromStore({ storeVal: this.storeFilter });
      } else {
        this.settingList(this.filterList);
      }
      this.filterModal = false;
    },
  },
};
</script>

<style>
.filter-date
  > div
  > div
  > .v-date-picker-table
  > table
  > tbody
  > tr
  > td
  > .v-date-picker-table
  .v-btn.v-btn--active {
  background: #8ca9dd !important;
  color: #414141 !important;
  border: 1px solid #8ca9dd !important;
}

.min-height-28 > div > div > div > div {
  padding: 3px;
}
.min-height-23 > div > div > div > div {
  padding: 3px;
}
/* .min-height-23 > .v-input--is-dirty > div > div > div > i {
  background: #767676 !important;
  border-radius: 3px;
}

.min-height-28 > .v-input--is-dirty > div > div > div > i {
  background: #767676 !important;
  border-radius: 3px;
} */
</style>
<style scoped lang="scss">
* {
  // overflow-y: hidden;
}
/** v-checkbox */
::v-deep .v-input--selection-controls {
  margin-top: 0%;
  padding-top: 0px;
}
::v-deep .v-label {
  color: #222222;
  font-size: 14px;
}
/** v-checkbox 크기 */
::v-deep .v-input--selection-controls__input {
  .v-icon {
    font-size: 19px;
  }
}
::v-deep .v-input--selection-controls__ripple {
  height: 24px;
  width: 24px;
  left: -7px;
  top: calc(50% - 19px);
}
::v-deep .v-list-item__icon:last-of-type:not(:only-child) {
  margin-right: 16px;
}
.min-height-23 {
  ::v-deep .v-label {
    font-size: 14px;
  }
}
::v-deep .v-label--is-disabled {
  color: #a5a5a5;
}
.custom-select ::v-deep .v-list-item--active {
  background-color: #3a6eff !important;
}
::v-deep .v-input {
  font-family: "Noto Sans KR";
  font-size: 14px;
}
/** v-radio */
::v-deep .v-input--selection-controls__ripple {
  color: #3a6eff !important;
  caret-color: #3a6eff !important;
}
::v-deep .primary--text:before {
  color: #3a6eff !important;
  caret-color: #3a6eff !important;
}
.d-inblock {
  display: inline-block;
}
.filter-status {
  border: 1px solid #2383e2;
  border-radius: 15px;
  background: white;
  color: #2383e2;
  min-height: 30px;
  height: fit-content;
  display: flex;
  align-items: center;
  padding: 4px 16px;
  font-size: 14px;
  margin-bottom: 8px;
  white-space: normal;
  word-break: break-word;
}
.filter-content {
  width: 100%;
}
.filter-range {
  border: 1px solid #2383e2;
  border-radius: 15px;
  background: white;
  color: #2383e2;
  width: 100%;
  height: fit-content;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 4px 16px;
  font-size: 14px;
  margin-bottom: 8px;
  white-space: normal;
  word-break: break-word;
}

.picker-btn {
  font-family: "Noto Sans KR";
  font-size: 17px;
  font-weight: 700;
  flex: 1;
}
::v-deep .v-btn > span {
  height: 100%;
  display: flex;
  align-items: center !important;
  line-height: 0.5 !important;
}

.body-text {
  font-family: "Noto Sans KR";
  font-size: 16px;
  font-weight: 500;
  color: #666666;
}
.topper-text {
  font-family: "Noto Sans KR";
  color: #222222;
  font-size: 20px;
  font-weight: 500;
  padding: 20px 20px 0px 20px;
}

.min-height-23 {
  min-height: 34px;
  font-family: "Noto Sans KR";
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0em;
  text-align: left;
}
.min-height-28 {
  min-height: 34px;
  font-family: "Noto Sans KR";
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0em;
  text-align: left;
}
.width-140 {
  width: 140px;
}

.month-year-text {
  width: 140px;
  height: 24px;
  background: #eeeeee;
  font-family: "Noto Sans KR";
  font-size: 14px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-text {
  font-family: "Noto Sans KR";
  width: 200px;
  padding: 16px 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 5px;
  color: white;
  font-size: 16px;
  font-weight: 400;
}

.filter-btn {
  width: 100px;
  height: 32px;
  border: 1px solid #5c5c5c;
  border-radius: 3px;
  cursor: pointer;
  line-height: 0;
}

.filter-btn1 {
  background: #f0f8ff;
  width: 100px;
  height: 32px;
  border: 1px solid #2383e2;
  border-radius: 3px;
  cursor: pointer;
  color: #2383e2;
}
.bottom-btns {
  padding-bottom: 20px;
}
.input-range {
  width: 125px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border-radius: 5px;
  border: 1px solid #999999;
  background: #ffffff;
  > input {
    width: 100%;
    font-size: 14px;
    color: #666666;
    &::placeholder {
      color: #666666;
      font-size: 14px;
    }
  }
}
.range-date-title {
  font-size: 12px;
  font-weight: 400;
  color: #999999;
  margin-bottom: 5px;
}
</style>
